<template>
	<div id="app">
		<div id="logo">
			<img src="img/dayunjituan.png">
		</div>
		<h2>大运汽车应聘人员履历表</h2>
		<el-form ref="form" :model="form" label-width="120px">
			<el-input v-model="form.jiben.id" type="hidden"></el-input>

			<div class="el-main">
				<el-row>
					<el-col :span="6">
						<el-form-item label="应聘岗位" prop="jiben.ypgw" :rules="rules.ypgw">
							<el-input v-model="form.jiben.ypgw"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="填表日期">
							<el-date-picker type="date" placeholder="请选择日期" v-model="tbrq" style="width: 100%;" value-format="yyyy-MM-dd"
							 readonly></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="招聘方式" prop="jiben.zpfs" :rules="rules.zpfs" >
							<el-cascader v-model="zpfs" :options="json.zpfs" @change="toggleZpfs()" placeholder="请选择招聘方式" :disabled="zpfsDisabled" ></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="推荐人" v-show="zpqdShow">
							<el-input v-model="form.jiben.zpqd1"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div class="el-main">
				<el-row>
					<el-col :span="6">
						<el-form-item label="姓名" prop="jiben.xm" :rules="rules.xm">
							<el-input v-model="form.jiben.xm"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="性别" prop="jiben.xb" :rules="rules.xb">
							<el-select v-model="form.jiben.xb" placeholder="请选择性别">
								<el-option label="男" value="0"></el-option>
								<el-option label="女" value="1"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="出生日期" prop="jiben.csrq" :rules="rules.csrq">
							<el-date-picker type="date" placeholder="请选择日期" v-model="form.jiben.csrq" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="5" style="position: absolute;z-index: 99;right: 0;top: -10px;">
						<el-upload class="avatar-uploader" :action="api+'fileupload/file'" :show-file-list="false" :on-success="handleAvatarSuccess"
						 :before-upload="beforeAvatarUpload" name="picfile" :headers="headers">  
							<img v-if="form.jiben.zp" :src="api+form.jiben.zp+'.jpg'" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<span style="font-size: 12px;color: indianred;position: absolute;bottom: 50px;right: 0;left: 0;" v-show="showTip">请上传照片，不超过2M</span>
						</el-upload>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="身高" prop="jiben.sg" :rules="rules.sg">
							<el-input v-model.number="form.jiben.sg" id="sg"></el-input><i style="position: absolute;right: 20px;">cm</i>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="民族" prop="jiben.mz" :rules="rules.mz">
							<el-select v-model="form.jiben.mz" filterable placeholder="请选择名族">
								<el-option v-for="item in json.mz" :key="item.id" :value="item.value" :label="item.label"></el-option>
							</el-select>
						</el-form-item>

					</el-col>
					<el-col :span="6">
						<el-form-item label="婚姻状况" prop="jiben.hyzk" :rules="rules.hyzk">
							<el-select v-model="form.jiben.hyzk" placeholder="请选择婚姻状况">
								<el-option v-for="item in json.hyzk" :key="item.id" :value="item.value" :label="item.label"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="身份证号" prop="jiben.sfzh" :rules="rules.sfzh">
							<el-input v-model="form.jiben.sfzh"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="政治面貌" prop="jiben.zzmm" :rules="rules.zzmm">
							<el-select v-model="form.jiben.zzmm" placeholder="请选择政治面貌">
								<el-option label="党员" value="0"></el-option>
								<!-- <el-option label="团员" value="1"></el-option> -->
								<!-- <el-option label="其他党派" value="2"></el-option> -->
								<el-option label="群众" value="3"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="国籍" prop="jiben.gj" :rules="rules.gj">
							<el-input v-model="form.jiben.gj"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="籍贯" prop="jiben.jg" :rules="rules.jg">
							<el-cascader v-model="jg" :options="json.jg" @change="form.jiben.jg=jg[1]" placeholder="请选择籍贯"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="学历" prop="jiben.xl" :rules="rules.xl">
							<el-select v-model="form.jiben.xl" placeholder="请选择学历">
								<el-option v-for="item in json.xl" :key="item.id" :value="item.value" :label="item.label"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="家庭住址" prop="jiben.jtzz" :rules="rules.jtzz">
							<el-input v-model="form.jiben.jtzz"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>

					<el-col :span="6">
						<el-form-item label="手机号码" prop="jiben.sjhm" :rules="rules.sjhm">
							<el-input v-model="form.jiben.sjhm"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="紧急联络人" prop="jiben.jjlxr" :rules="rules.jjlxr">
							<el-input v-model="form.jiben.jjlxr"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">

						<el-form-item label="紧急联络电话" prop="jiben.jjlldh" :rules="rules.jjlldh">
							<el-input v-model="form.jiben.jjlldh"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">

						<el-form-item label="健康状况" prop="jiben.jkzk" :rules="rules.jkzk">
							<el-input v-model="form.jiben.jkzk" placeholder="请如实填写"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="汽车驾驶证" prop="jiben.qcjs">
							<!-- <el-input v-model="form.jiben.qcjs" placeholder="如有请填写所持驾照类型"></el-input> -->
							<el-select v-model="form.jiben.qcjs" placeholder="请选择汽车驾驶证">
								<el-option v-for="item in json.qcjsz" :key="item.id" :value="item.value" :label="item.label"></el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="特殊群体">
							<el-select v-model="form.jiben.tsqt" placeholder="请选择特殊群体">
								<el-option label="" value=""></el-option>
								<el-option label="低保户" value="0"></el-option>
								<el-option label="残疾人" value="1"></el-option>
								<el-option label="其他" value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="是否有亲友在我司工作" label-width="160px" prop="sfyqyzwsgz">
							<el-select v-model="sfyqyzwsgz">
								<el-option label="是" value="1"></el-option>
								<el-option label="否" value="无"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="2" v-show="sfyqyzwsgz==1">
						<el-form-item label="" label-width="10px">
							<el-input v-model="sfyqyzwsgz_xm" style="width: 110px;" placeholder="亲友姓名"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="2" v-show="sfyqyzwsgz==1">
						<el-form-item label-width="10px">
							<el-input v-model="sfyqyzwsgz_bm" style="width: 110px;" placeholder="亲友部门"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="2" v-show="sfyqyzwsgz==1">
						<el-form-item label-width="10px">
							<el-input v-model="sfyqyzwsgz_gx" style="width: 110px;" placeholder="关系"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div class="el-main main-table">
				<el-row>
					<el-form-item style="text-align: left;">
						教育经历 <i class="el-icon-circle-plus" @click="form.jyjl.push({})"></i>
					</el-form-item>

				</el-row>
				<el-table :data="form.jyjl" border stripe empty-text="暂无数据">
					<el-table-column type="index" width="30">
					</el-table-column>
					<el-table-column label="起止时间" width="280">
						<template slot-scope="scope">
							<input v-model="form.id" type="hidden" />
							<input v-model="scope.row.mainid" type="hidden" />
							<el-form-item :prop="'jyjl.'+scope.$index+'.sj'" label=" " label-width="1" required :rules="[{required:true,message:'请输入起止时间'}]">
								<el-date-picker type="daterange" v-model="scope.row.sj" style="width: 89%;" value-format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
						</template>
					</el-table-column>
					<!-- <el-table-column label="结束时间" width="180">
						<template slot-scope="scope">
							<el-form-item :prop="'jyjl.'+scope.$index+'.jssj'" label=" " label-width="1" required :rules="[{required:true,message:'请输入结束时间',trigger:'blur'}]">
								<el-date-picker type="daterange" placeholder="结束时间" v-model="scope.row.jssj" style="width: 89%;" value-format="yyyy-MM-dd" ></el-date-picker>
							</el-form-item>
						</template>
					</el-table-column> -->
					<el-table-column label="毕业院校" width="220">
						<template slot-scope="scope">
							<el-form-item :prop="'jyjl.'+scope.$index+'.byyx'" label=" " label-width="1" required :rules="[{required:true,message:'请输入毕业院校',trigger:'blur'}]">
								<el-input v-model="scope.row.byyx" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="专业" width="220">
						<template slot-scope="scope">
							<el-form-item :prop="'jyjl.'+scope.$index+'.zy'" label=" " label-width="1" required :rules="[{required:true,message:'请输入专业',trigger:'blur'}]">
								<el-input v-model="scope.row.zy" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="学历" width="160">
						<template slot-scope="scope">
							<el-form-item :prop="'jyjl.'+scope.$index+'.xl'" label=" " label-width="1" required :rules="[{required:true,message:'请选择学历',trigger:'blur'}]">
								<el-select v-model="scope.row.xl" class="table-list-item" placeholder="请选择学历">
									<el-option v-for="item in json.xl" :key="item.id" :value="item.value" :label="item.label"></el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="学历类型" width="220">
						<template slot-scope="scope">
							<el-form-item :prop="'jyjl.'+scope.$index+'.xllx'" label=" " label-width="1" required :rules="[{required:true,message:'请选择学历类型',trigger:'blur'}]">
								<el-select v-model="scope.row.xllx" class="table-list-item" placeholder="请选择学历类型">
									<el-option v-for="item in json.xllx" :key="item.id" :value="item.value" :label="item.label"></el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="院校性质" width="200">
						<template slot-scope="scope">
							<el-form-item :prop="'jyjl.'+scope.$index+'.yxxz'" label=" " label-width="1">
								<el-select v-model="scope.row.yxxz" class="table-list-item" placeholder="请选择院校性质">
									<el-option v-for="item in json.yxxz" :key="item.id" :value="item.value" :label="item.label"></el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="从学单位类别" width="220">
						<template slot-scope="scope">
							<el-form-item :prop="'jyjl.'+scope.$index+'.cxdwlb'" label=" " label-width="1">
								<el-select v-model="scope.row.cxdwlb" class="table-list-item" placeholder="请选择从学单位类别">
									<el-option v-for="item in json.cxdwlb" :key="item.id" :value="item.value" :label="item.label"></el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<i class="el-icon-delete-solid" @click="deleteRow(scope.$index, form.jyjl)"></i>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="el-main main-table">
				<el-row>
					<el-form-item style="text-align: left;">
						工作经历 <i class="el-icon-circle-plus" @click="form.gzjl.push({})"></i>
					</el-form-item>
				</el-row>
				<el-table :data="form.gzjl" border stripe empty-text="暂无数据">
					<el-table-column type="index" width="30">
					</el-table-column>
					<el-table-column label="起止时间" width="290">
						<template slot-scope="scope">
							<input v-model="form.id" type="hidden" />
							<input v-model="scope.row.mainid" type="hidden" />
							<el-form-item :prop="'gzjl.'+scope.$index+'.sj'" label=" " label-width="1" required :rules="[{required:true,message:'请输入起止时间'}]">
								<el-date-picker type="daterange" placeholder="起止时间" v-model="scope.row.sj" style="width: 89%;" value-format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
						</template>
					</el-table-column>
					<!-- <el-table-column label="结束时间" width="190">
						<template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.jssj'" label=" " label-width="1" required :rules="[{required:true,message:'请输入结束时间',trigger:'blur'}]">
								<el-date-picker type="date" placeholder="结束时间" v-model="scope.row.jssj" style="width: 80%;" value-format="yyyy-MM-dd"></el-date-picker>
							</el-form-item>
						</template>
					</el-table-column> -->

					<el-table-column label="所属城市" width="270">
						<template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.sscs'" label=" " label-width="1" required :rules="rules.sscs">
								<el-cascader :ref="'cascaderAddr'+scope.$index" :options="json.jg" @change="setSscs($event,scope.$index)"
								 placeholder="请选择所属城市"></el-cascader>
							</el-form-item>
						</template>
					</el-table-column>


					<el-table-column label="工作单位" width="170"><template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.gzdw'" label=" " label-width="1" required :rules="[{required:true,message:'请输入工作单位',trigger:'blur'}]">
								<el-input v-model="scope.row.gzdw" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="部门" width="170"><template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.gzbm'" label=" " label-width="1" required :rules="[{required:true,message:'请输入部门',trigger:'blur'}]">
								<el-input v-model="scope.row.gzbm" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="岗位" width="170"><template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.gw'" label=" " label-width="1" required :rules="[{required:true,message:'请输入岗位',trigger:'blur'}]">
								<el-input v-model="scope.row.gw" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="月薪" width="110">
						<template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.yx'" label=" " label-width="1" :rules="rules.qwxzsqyx">
								<el-input v-model.number="scope.row.yx" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="年收入" width="120">
						<template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.nsr'" label=" " label-width="1">
								<el-input v-model="scope.row.nsr" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="离职原因" width="170">
						<template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.lzyy'" label=" " label-width="1" required :rules="[{required:true,message:'请输入离职原因',trigger:'blur'}]">
								<el-input v-model="scope.row.lzyy" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="证明人" width="150">
						<template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.zmr'" label=" " label-width="1" required :rules="[{required:true,message:'请输入证明人',trigger:'blur'}]">
								<el-input v-model="scope.row.zmr" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="证明人电话" width="170">
						<template slot-scope="scope">
							<el-form-item :prop="'gzjl.'+scope.$index+'.zmrdh'" label=" " label-width="1" :rules="rules.jjlldh">
								<el-input v-model="scope.row.zmrdh" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<i @click="deleteRow(scope.$index, form.gzjl)" class="el-icon-delete-solid"></i>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="el-main main-table">
				<el-row>
					<el-form-item style="text-align: left;">
						家庭关系 <i class="el-icon-circle-plus" @click="form.jtgx.push({})"></i>
					</el-form-item>
				</el-row>
				<el-table :data="form.jtgx" border stripe empty-text="暂无数据">
					<el-table-column type="index" width="30">
					</el-table-column>
					<el-table-column label="姓名" width="220"><template slot-scope="scope">
							<input v-model="form.id" type="hidden" />
							<input v-model="scope.row.mainid" type="hidden" />
							<el-form-item :prop="'jtgx.'+scope.$index+'.xm'" label=" " label-width="1" required :rules="[{required:true,message:'请输入姓名',trigger:'blur'}]">
								<el-input v-model="scope.row.xm" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="与本人关系" width="220"><template slot-scope="scope">
							<el-form-item :prop="'jtgx.'+scope.$index+'.ybrgx'" label=" " label-width="1" required :rules="[{required:true,message:'请输入与本人关系',trigger:'blur'}]">
								<!-- <el-input v-model="scope.row.ybrgx" class="table-list-item"></el-input> -->
								<el-select v-model="scope.row.ybrgx" class="table-list-item" placeholder="请选择与本人关系">
									<el-option v-for="item in json.jtgx" :key="item.id" :value="item.value" :label="item.label"></el-option>
								</el-select>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="年龄" width="220"><template slot-scope="scope">
							<el-form-item :prop="'jtgx.'+scope.$index+'.nl'" label=" " label-width="1" :rules="rules.nl">
								<el-input v-model.number="scope.row.nl" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="工作单位">
						<template slot-scope="scope">
							<el-form-item :prop="'jtgx.'+scope.$index+'.gzdw'" label=" " label-width="1" required :rules="[{required:true,message:'请输入工作单位',trigger:'blur'}]">
								<el-input v-model="scope.row.gzdw" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="职务" width="220">
						<template slot-scope="scope">
							<el-form-item :prop="'jtgx.'+scope.$index+'.zw'" label=" " label-width="1" required :rules="[{required:true,message:'请输入职务',trigger:'blur'}]">
								<el-input v-model="scope.row.zw" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="联系电话" width="220">
						<template slot-scope="scope">
							<el-form-item :prop="'jtgx.'+scope.$index+'.lxdh'" label=" " label-width="1" :rules="rules.jjlldh">
								<el-input v-model="scope.row.lxdh" class="table-list-item"></el-input>
							</el-form-item>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="50">
						<template slot-scope="scope">
							<i @click="deleteRow(scope.$index, form.jtgx)" class="el-icon-delete-solid"></i>
						</template>
					</el-table-column>
				</el-table>
			</div>



			<div class="el-main">
				<el-row>
					<el-col :span="2">
						<el-form-item label="期望薪资(税前)"></el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="月薪" prop="jiben.qwxzsqyx" :rules="rules.qwxzsqyx">
							<el-input v-model.number="form.jiben.qwxzsqyx"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="年薪">
							<el-input v-model="form.jiben.qwxzsqnx"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</div>
			<div class="el-main">
				<el-row>
					<el-form-item label="请从以下三项中只选择一项：" prop="jiben.qcyxsxxzxzyg" :rules="rules.qcyxsxxzxzyg" label-width="220px">
						<el-radio-group v-model="form.jiben.qcyxsxxzxzyg">
							<el-radio class="qcyxsxxzxzyg" :label="0">我与任何单位均未签订过劳动合同，若因此产生的纠纷，由我本人承担。</el-radio>
							<el-radio class="qcyxsxxzxzyg" :label="1">我已与原工作单位解除劳动合同、清理完相关离职手续。若因此产生的纠纷，由我本人承担。</el-radio>
							<el-radio class="qcyxsxxzxzyg" :label="2">我尚未与原工作单位解除劳动合同，若因此产生的纠纷，由我本人承担。</el-radio>
						</el-radio-group>
					</el-form-item>
					<div style="margin: 30px auto;">
						<el-col :span="1">
							<el-checkbox v-model="checked"></el-checkbox>
						</el-col>
						<el-col :span="23">
							<div style="color: red;text-align: left;font-size: 15px;padding-bottom: 40px;">本人在此表格上所写的一切资料均真实，本人充分了解上述资料的真实性是双方订立劳动合同的前提条件，如有弄虚作假或隐瞒的情况，属于严重违反公司规章制度，同意公司有权解除劳动合同或对劳动合同做无效认定处理。</div>
						</el-col>
					</div>
				</el-row>
			</div>
			<el-row style="margin-top: 40px;text-align: center;" v-show="showBtn">
				<el-form-item>
					<el-button type="primary" @click="onSubmit" :disabled="!checked">提交</el-button>
					<!-- <el-button type="primary" @click="onSubmit" >提交</el-button> -->
					<el-button>取消</el-button>
				</el-form-item>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import $ from 'jquery'
	export default {
		name: 'App',
		methods: {
			onSubmit() {
				const _this = this;
				if (this.form.jiben.zp == "") {
					_this.$message({
						message: '请上传照片！',
						type: 'error'
					});
					return;
				}
// 处理起止时间
				_this.$refs['form'].validate(function(valid) {
					if (valid) {
						_this.$confirm('提交之后不能再修改, 是否提交?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(function() {
							// 处理form.jiben.sfyqyzwsgz
							_this.form.jiben.sfyqyzwsgz = _this.sfyqyzwsgz;
							if (_this.sfyqyzwsgz == "1") {
								_this.form.jiben.sfyqyzwsgz = _this.sfyqyzwsgz_xm + " " + _this.sfyqyzwsgz_bm + " " + _this.sfyqyzwsgz_gx;
							}
							// 处理起止时间
							_this.form.jyjl.forEach(item=>{
								item.kssj = item.sj[0]
								item.jssj= item.sj[1]
							})
							_this.form.gzjl.forEach(item=>{
								item.kssj = item.sj[0]
								item.jssj= item.sj[1]
							})
							$.ajax({
								url: _this.api + "jianliku/add",
								headers: {
									'Content-Type': 'application/json',
									'token':_this.token
								},
								type: 'post',
								dataType: "json",
								data: JSON.stringify(_this.form),
								success: function(result) {
									if (result.resultMessage.messageCode == "SUCCESS") {
										_this.$message({
											message: '提交成功！',
											type: 'success'
										});
										_this.showBtn = false;
									} else {
										_this.$message.error('提交失败！' + result.resultMessage.messageText);
									}
								},
								error: function() {
									_this.$message({
										message: "请求失败",
										type: 'error',
									});
								}
							});

						}).catch(function(error) {
							_this.$message({
								type: 'info',
								message: '已取消提交' + error
							});
						});
					} else {
						_this.$message({
							message: '请填写必填项！',
							type: 'error'
						});
					}
				})
			},
			handleAvatarSuccess(res) {
				if (res.resultMessage.messageCode == "SUCCESS") {
					this.form.jiben.zp = res.resultData;
					this.showTip = false;
				} else {
					this.$message.error('上传失败！');
				}
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			deleteRow(index, rows) {
				rows.splice(index, 1);
			},
			getToken(){
					let _this = this;
					// let url = this.api + "jianliku/login";
					let url = this.api + "login";
					$.ajax({
						url: url,
						type: 'post',
						data:_this.userInfo,
						headers: {
							'Content-Type': 'application/json',
						},
						success: function(result) {
							if (result.resultMessage.messageCode == "SUCCESS") {
								_this.token = result.resultData.token;
								if(_this.json!={}){
									_this.loadJson();
									_this.headers = {'token':_this.token}
								}
							} else {
								_this.$message({
									message: result.resultMessage.messageText,
									type: 'error',
								});
							}
						},
						error: function() {
							_this.$message({
								message: "请求失败",
								type: 'error',
							});
						}
					});
			},
			// 加载可选列表
			loadJson() {
				if(this.token!=''){
					console.log(this.token)
					let _this = this;
					let url = this.api + "jianliku/getallzhiji";
					$.ajax({
						url: url,
						type: 'post',
						headers: {
							'Content-Type': 'application/json',
							'token':_this.token
						},
						success: function(result) {
							if (result.resultMessage.messageCode == "SUCCESS") {
								_this.json = result.resultData;
							} else {
								_this.$message({
									message: result.resultMessage.messageText,
									type: 'error',
								});
							}
						},
						error: function() {
							_this.$message({
								message: "请求失败",
								type: 'error',
							});
						}
					});
				}else{
					this.getToken();
				}
			},
			// 如招聘方式选其他，显示招聘渠道编辑框
			toggleZpfs() {
				this.form.jiben.zpfs = this.zpfs[0];
				this.form.jiben.zpqd = this.zpfs[1];
				this.zpfs.length == 1 ? this.zpqdShow = true : this.zpqdShow = false;
			},
			// 设置所属城市
			setSscs(val, index) {
				let v = this.$refs['cascaderAddr' + index].getCheckedNodes()[0].data.label;
				this.form.gzjl[index].sscs = v;
			},
		},
		mounted() {
			this.getToken();
			this.loadJson();
			this.form.jiben.gj == "" ? this.form.jiben.gj = "中国" : this.form.jiben.gj = "";
			// 从官网过来的需要设置招聘方式为公司官网并设置为只读 对应值为2 39
			let href = window.location.href;
			let strs = href.split("?");
			if(strs.length>1){
				let type = strs[1].split("=")[1];
				if(type == 1 || type ==2){
					console.log("我从官网来")
					this.zpfsDisabled = true;
					this.zpfs=["2","39"]
				}
			}
		},
		data: function() {
			let _this = this;
			return {
				token:'',
				headers:{},
				userInfo:JSON.stringify({
					'userName':'670119D1B699F552EFB0E990792FFBDD',
					'password':'670119D1B699F552EFB0E990792FFBDD',
					}),
				json: {},
				zpqdShow: false,
				// api: 'http://10.1.20.133:8082/',
				api: 'http://jianliku.dayunmotor.com:18880/api/',
				// api: '/api/',
				jg: '',
				zpfs: [],
				checked: false,
				tbrq: new Date(),
				showBtn: true,
				showTip: true,
				sfyqyzwsgz: '否',
				sfyqyzwsgz_xm: '',
				sfyqyzwsgz_bm: '',
				sfyqyzwsgz_gx: '',
				zpfsDisabled:false,
				form: {
					jiben: {
						id: 0,
						ypgw: '',
						// tbrq: new Date(),
						xm: '',
						xb: '',
						csrq: '',
						sg: '',
						sfzh: '',
						zzmm: '',
						jtzz: '',
						sjhm: '',
						jjlldh: '',
						qcjs: '',
						sfyqyzwsgz: '无',
						zp: '',
						picfile: '',
						qwxzsqyx: '',
						qwxzsqnx: '',
						gj: '',
						mz: '17',
						hyzk: '',
						zpfs: '',
						zpqd: '',
						jjlxr: '',
						zpqd1: '',
						xl: '',
						qcyxsxxzxzyg: '',
						tsqt: '',
						jg: '',
					},
					jyjl: [],
					gzjl: [],
					jtgx: []
				},
				rules: {
					ypgw: [{
						required: true,
						message: '请输入应聘岗位',
						trigger: 'blur'
					}],
					zpfs: [{
						required: true,
						message: '请选择招聘方式',
						trigger: 'change'
					}],
					xm: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					csrq: [{
						required: true,
						message: '请输入出生日期',
						trigger: 'blur'
					}],
					sg: [{
						required: true,
						message: '请输入身高',
						trigger: 'blur'
					}, {
						type: 'number',
						message: '身高必须为数字值',
						trigger: 'blur'
					}],
					zzmm: [{
						required: true,
						message: '请选择政治面貌',
						trigger: 'change'
					}],
					xb: [{
						required: true,
						message: '请选择性别',
						trigger: 'blur'
					}],
					mz: [{
						required: true,
						message: '请选择民族',
						trigger: 'change'
					}],
					hyzk: [{
						required: true,
						message: '请选择婚姻状况',
						trigger: 'change'
					}],
					sfzh: [{
						required: true,
						message: '请输入身份证号',
						trigger: 'blur'
					}, {
						pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
						message: '身份证格式不正确',
						trigger: 'blur'
					}, {
						validator: function(rule, value, callback) {
							$.ajax({
								url: _this.api + "jianliku/checksfzh",
								type: 'post',
								dataType: 'json',
								headers: {
									'Content-Type': 'application/json',
									'Token':_this.token
								},
								data: _this.form.jiben.sfzh,
								success: function(result) {
									if (result.resultMessage.messageCode == "SUCCESS") {
										callback();
									} else {
										callback(new Error(result.resultMessage.messageText));
									}
								},
								error: function(result) {
									_this.$message({
										message: result.resultMessage.messageText,
										type: 'error',
									});
								}
							});
						},
						trigger: 'blur'
					}],
					// sscs: [{
						// validator: function(rules, value, callback) {},
						// trigger: 'change'
					// }],
					jg: [{
						required: true,
						message: '请选择籍贯',
						trigger: 'change'
					}],
					xl: [{
						required: true,
						message: '请选择学历',
						trigger: 'change'
					}],
					sjhm: [{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}, {
						pattern: /^1[34578]\d{9}$/,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}],
					jjlldh: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}, {
						pattern: /^1[34578]\d{9}$/,
						message: '请输入正确的电话号码',
						trigger: 'blur'
					}],
					jkzk: [{
						required: true,
						message: '请输入健康状况',
						trigger: 'blur'
					}],
					jjlxr: [{
						required: true,
						message: '请输入紧急联系人',
						trigger: 'blur'
					}],
					qwxzsqyx: [{
						required: true,
						message: '请输入月薪',
						trigger: 'blur'
					}, {
						type: 'number',
						message: '月薪必须为数字值',
						trigger: 'blur'
					}, ],
					nl: [{
						required: true,
						message: '请输入年龄',
						trigger: 'blur'
					}, {
						type: 'number',
						message: '年龄必须为数字值',
						trigger: 'blur'
					}, ],
					qcyxsxxzxzyg: [{
						required: true,
						message: '请至少选择一项',
						trigger: 'change'
					}],
					jtzz: [{
						required: true,
						message: '请输入家庭住址',
						trigger: 'blur'
					}],
				}
			}
		}

	}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}

	.table-list-item {
		width: 89% !important;
	}

	.main-table .el-form-item__label {
		padding: 0 !important;
	}

	.main-table .el-form-item__label:before {
		margin: 0 !important;
	}

	.el-icon-circle-plus {
		color: #3A8EE6;
		font-size: 18px;
	}

	.qcyxsxxzxzyg {
		display: block !important;
		line-height: 40px !important;
		text-align: left;
	}

	.el-main {
		margin-top: 30px;
		padding: 20px 20px 0px 20px;
		background-color: #f8f8f8;
	}

	.main-table {
		padding-bottom: 30px;
	}

	.main-table .el-form-item {
		margin-bottom: 5px;
	}

	.main-table .el-form-item .el-form-item__error {
		top: 50%;
		left: 30%;
		right: 0;
	}

	.main-table .el-form-item .el-form-item__content {
		margin-left: 0 !important;
	}

	body {
		background-image: url("/img/bg.gif");
		background-repeat: repeat;
		background-color: #0a0a0a;
	}

	.tip {
		position: absolute;
		color: red;
	}

	#app {
		width: 1440px;
		margin: 0 auto;
		background-color: #ffffff;
		box-shadow: 0 2px 15px rgba(0, 0, 0, .15);
		padding: 40px;
		border-radius: 10px;
	}

	#app h2 {
		text-align: center;
		margin: 30px 0 20px 0;
	}

	.avatar-uploader {
		text-align: center;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background-color: #FFF;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 248px;
		line-height: 248px !important;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 230px;
		display: block;
	}

	.el-icon-circle-plus-outline {
		cursor: pointer;
		color: #3A8EE6;
		font-size: 24px;
	}

	#logo {
		position: relative;
	}

	#logo img {
		width: 175px;
		height: 56px;
		position: absolute;
		left: 0;
	}

	.el-table {
		width: 100%;
		margin: 0 auto;
	}

	.el-table .cell {
		text-align: center;
	}

	i {
		cursor: pointer;
	}

	.el-radio-group {
		display: block !important;
		/* margin-left: 300px !important; */
	}

	#sg {
		padding-right: 50px;
	}
</style>
		